import { render, staticRenderFns } from "./DriverDetail.vue?vue&type=template&id=157bba8f&scoped=true"
import script from "./DriverDetail.vue?vue&type=script&lang=js"
export * from "./DriverDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverDetail.vue?vue&type=style&index=0&id=157bba8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157bba8f",
  null
  
)

export default component.exports